import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCustomer } from "@lib/context/shared/customer-context";
import { useFormatter } from "next-intl";
import { useMemo } from "react";
/**
 * Format a number to a money display depends on the customer currency
 * @param quantity is an amount of money
 * @returns
 */
export function useMoneyDisplay(quantity) {
  var _quantity;
  let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let useCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  let maxFractionDigits = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2;
  const format = useFormatter();
  const currency = useCustomer().customerCurrency;
  const isPriseWithCurrencies = typeof quantity !== "number";
  const priceFromCurrencies = isPriseWithCurrencies ? (_quantity = quantity === null || quantity === void 0 ? void 0 : quantity[currency]) !== null && _quantity !== void 0 ? _quantity : 0 : quantity !== null && quantity !== void 0 ? quantity : 0;
  return useMemo(() => {
    let code = format.number(0, _objectSpread({
      currency,
      style: "currency",
      currencyDisplay: "code",
      maximumFractionDigits: 0,
      minimumFractionDigits: 0
    }, opts)).replace(/\d/g, '').trim();
    let currencySymbol = format.number(0, _objectSpread({
      currency,
      style: "currency",
      currencyDisplay: "narrowSymbol",
      maximumFractionDigits: 0,
      minimumFractionDigits: 0
    }, opts)).replace(/\d/g, '').trim();
    if (currencySymbol === 'PEN') {
      currencySymbol = 'S/';
    }

    // Format number with comma for thousands separator and period for decimals
    const formattedNumber = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: maxFractionDigits,
      useGrouping: true
    }).format(priceFromCurrencies);
    return " ".concat(useCode ? code : '', " ").concat(currencySymbol, " ").concat(formattedNumber);
  }, [format, quantity, currency, opts, useCode, maxFractionDigits, priceFromCurrencies]);
}
export default useMoneyDisplay;